async function pushSave() {
    if (this.canPushProduct()) {
        await this.cmdPushSave()
    }
    else if (this.canSaveMap()) {
        await this.cmdSaveMap()
    }
}

export default () => ({
    'Ctrl+S': pushSave,
    'Meta+S': pushSave,
})
